export default "__VITE_ASSET__D0ePGR7U__"